module.exports = __webpack_public_path__ + "static/media/empty_user_insta.f63a8110.svg";